
import React, { useState, useRef } from "react"
import Background from '../../static/img/bg-home.png';
import { Row, Col, Button } from "antd";
import { useNavigate } from 'react-router-dom'
const HomePage = () => {
	const navigate = useNavigate();
	const ref = useRef(null);
	const [bgHeight, setbgHeight] = useState(0);

	const [isShowIcon, setIsShowIcon] = useState(false)
	const [userName, setName] = useState('Sign In')

	const getWindowSize = () => ({
		innerHeight: window.innerHeight,
		innerWidth: window.innerWidth,
	});


	const handleResize = () => {
		setbgHeight(getWindowSize().innerWidth/1440*521)
	};

	React.useEffect(() => {
		const name = sessionStorage.getItem("userName")
		if (name !== null) {
			setName(name)
			setIsShowIcon(true)
		}
	
		setbgHeight(ref.current.offsetWidth/1440*521)
		// 监听
		window.addEventListener('resize', handleResize);
		// 销毁
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	function onClick() {
		if (userName === 'Sign In') {
			//登陆
			navigate('../sign',)
		} else {
			//进入developerCenter
			sessionStorage.setItem("key", 'developerCenter/dataNotification')
			navigate('../developerCenter',)
		}
	}
	return (
		<div  ref={ref}style={{ backgroundSize: 'cover', minHeight: '521px', height: bgHeight, backgroundImage: `url(${Background})`, }}>
			<Row>
				<Col span={12}>
					<img src={require('../../static/img/ic-home-logo.png')} alt="logo"
						style={{ marginTop: '19px', marginLeft: '63px' }} height="36px" />
				</Col>
				<Col span={12} style={{ display: 'flex', justifyContent: 'right', }}>
					<Row >
						<Col >
							<img src={require('../../static/img/ic-head-portrait.png')} alt="logo"
								style={{ display: isShowIcon ? 'block' : 'none', marginTop: '19px', marginLeft: '63px' }} height="36px" />
						</Col>
						<Col >
							<Button onClick={onClick} type='text' style={Styles.appTitleName}>{userName}</Button>
						</Col>
					</Row>
				</Col>
			</Row>
			<div style={{ paddingTop: '174px', paddingLeft: '100px' }}>
				<span style={Styles.appTextLarge}>
					Become a partner of
				</span>
				<span style={Styles.appTextLarge}>
					iHealth
				</span>
			</div>
		</div>
	)
}

const Styles = {

	appTitleName: {
		width: '66px',
		height: '20.48px',
		fontSize: '20px',
		marginRight: '74px',
		marginLeft: '5px',
		marginTop: "20px",
		fontWeight: 'normal',
		display: 'flex',
		border: 'none'
	},
	appTextLarge: {
		display: 'block',
		fontSize: '48px',
		fontWeight: '600',
		color: '#FF5300',
		whiteSpace: "pre-line"
	},

}

export default HomePage